import React from "react";
import { Layout } from "Components/Layout/Layout";
import { lazyLoader } from "Service/loader";
const ReminderContactList = lazyLoader(
  () => import("Containers/ReminderContact/ReminderDashboard/ReminderDashboard")
);

export const ReminderContactsListPage = () => {
  return (
    <Layout>
      <ReminderContactList />
    </Layout>
  );
};
